// extracted by mini-css-extract-plugin
export default {"Error":"Error_Error__PD6h7"};